import type { NavigateFunction } from 'react-router-dom';
import type { AuthState } from './types';

export const COMPLETE_PROFILE_PATH = '/complete-profile';

export function isProfileIncomplete(authState: Pick<AuthState, 'name' | 'phone'>): boolean {
  return !authState.name?.trim() || !authState.phone?.trim();
}

/**
 * Navigate to /complete-profile when the authenticated user is missing
 * name/phone, preserving the original target as `state.from` so the user
 * resumes there after saving. Returns true when the redirect fired so the
 * caller can short-circuit any post-login navigation.
 */
export function redirectIfProfileIncomplete(
  navigate: NavigateFunction,
  authState: Pick<AuthState, 'name' | 'phone'>,
  target: string,
): boolean {
  if (!isProfileIncomplete(authState)) return false;
  navigate(COMPLETE_PROFILE_PATH, {
    replace: true,
    state: { from: target },
  });
  return true;
}
